import { BaseService } from './base.service';

export class InventoryCategoriesService extends BaseService {
  static get resourceEndpoint() {
    return 'inventory-categories';
  }
}
